<template>
  <b-modal id="editGallery" centered modal-class="db-modal" @show="cargar">
    <template #modal-header>
      <div class="db-modal-head">
        <h2 class="db-modal-title">{{ esNueva ? "Nueva galería" : "Editar galería" }}</h2>
        <p class="db-modal-subtitle">Ponle un título y elige la foto de portada.</p>
      </div>
      <button type="button" class="db-icon-btn" aria-label="Cerrar" @click="closeModal">
        <span class="material-symbols-outlined">close</span>
      </button>
    </template>

    <form class="db-form" @submit.prevent="saveGallery">
      <div class="db-field">
        <label class="db-label" for="eg-titulo">Título</label>
        <input id="eg-titulo" v-model.trim="titulo" type="text" class="db-input" placeholder="Ej.: Semana Santa 2025" />
      </div>

      <div class="db-field">
        <span class="db-label">Portada</span>
        <button
          type="button"
          class="db-image-pick"
          :class="{ 'has-image': imagenPortada }"
          @click="$bvModal.show('editarGaleriaEditGal')"
        >
          <template v-if="imagenPortada">
            <img v-img-fallback :src="`${base}/img/minGallery/${imagenPortada}`" alt="Portada de la galería" />
            <span class="db-image-pick-overlay">
              <span class="material-symbols-outlined">swap_horiz</span> Cambiar
            </span>
          </template>
          <span v-else class="db-image-pick-empty">
            <span class="material-symbols-outlined">add_photo_alternate</span>
            Elegir portada
          </span>
        </button>
      </div>
    </form>

    <selectorImagenes id="editarGaleriaEditGal" @imagen="remplaceImage" />

    <template #modal-footer>
      <button type="button" class="db-btn db-btn--ghost" @click="closeModal">Cancelar</button>
      <button type="button" class="db-btn" :disabled="!activeModificarGaleria || guardando" @click="saveGallery">
        <span v-if="guardando" class="db-spinner"></span>
        {{ esNueva ? "Crear galería" : "Guardar cambios" }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import selectorImagenes from "../dashboard/SelectorImages.vue";
import axios from "@/directives/axios.js";
import { avisar, avisarError } from "@/directives/dbDialogs.js";

export default {
  name: "editGallery",
  props: ["dataGallery"],

  components: {
    selectorImagenes,
  },

  data() {
    return {
      titulo: "",
      imagenPortada: "",
      guardando: false,
      base: this.$media,
    };
  },
  computed: {
    esNueva() {
      return !this.dataGallery || this.dataGallery.id === "0";
    },
    activeModificarGaleria() {
      return !!this.titulo && !!this.imagenPortada;
    },
  },
  methods: {
    cargar() {
      this.titulo = (this.dataGallery && this.dataGallery.tituloNoticia) || "";
      this.imagenPortada = (this.dataGallery && this.dataGallery.imageSrc) || "";
    },
    remplaceImage(value) {
      if (value && value.length) this.imagenPortada = value[0].imagen;
    },
    async saveGallery() {
      if (!this.activeModificarGaleria) return;
      this.guardando = true;
      try {
        const { data } = await axios.post("/imagenes/nuevaGaleria", {
          // La API espera null para crear una galería nueva
          id: this.esNueva ? null : Number(this.dataGallery.id),
          titulo: this.titulo,
          imagenPortada: this.imagenPortada,
        });
        this.$emit("updateGalerias", data.todasGalerias);
        avisar(this, this.esNueva ? `Galería «${this.titulo}» creada. Ahora puedes añadirle fotos.` : `Se han guardado los cambios de «${this.titulo}».`, "success", this.esNueva ? "Galería creada" : "Galería modificada");
        this.closeModal();
      } catch (error) {
        avisarError(this, error, "No se pudo guardar la galería.");
      } finally {
        this.guardando = false;
      }
    },
    closeModal() {
      this.$bvModal.hide("editGallery");
    },
  },
};
</script>
